export default {
  LOGIN: 'login',
  SIGNUP: 'signup',
  AUTO_LOGIN: 'auto-login',
  ACCESS_RECOVERY: 'accessRecovery',
  USER: 'user',
  RESET_PASSWORD: 'resetPassword',
  EMAIL_VERIFICATION: 'emailVerification',
  PHONE_VERIFICATION: 'phoneVerification',
  UPDATE_PROFILE: 'updateProfile',
  LINK_SOCIAL_NETWORKS: 'linkSocialNetworks',
  HOME: 'home',
  EDIT_PROFILE: 'userEdit',
  POINTS: 'points',
  VIDEO_CONSULTATIONS: 'videoconsultations',
  VIDEO_CONSULTATIONS_STREAM: 'videoconsultations-stream',
  VIDEO_CONSULTATION: 'videoconsultation',
  VIDEO_CONSULTATION_STREAM: 'videoconsultation-stream',
  SUPPORT: 'support',
  SUPPORT_CATEGORY: 'support-category',
  SUPPORT_CATEGORY_STREAM: 'support-category-stream',
  SUBSCRIPTIONS: 'subscriptions',
  SUBSCRIPTION: 'subscription',
  COURSES: 'courses',
  CALENDAR: 'calendar',
  HOMEWORKS: 'homeworks',
  HOMEWORKS_STREAM: 'homeworks-stream',
  HOMEWORK: 'homework',
  CHAT: 'chat',
  CHATS: 'chats',
  CHAT_STREAM: 'chat-stream',
  MATERIALS: 'materials',
  DAY: 'day',
  LOGOUT: 'logout',
  DELETE: 'delete',
  SETTINGS: 'userSettings',
  SETTINGS_REMINDERS_TRAINING: 'settingsReminders',
  SETTINGS_REMINDER_TRAINING: 'settingsReminderUpdate',
  SETTINGS_NEW_REMINDER_TRAINING: 'settingsReminderNew',
  SETTINGS_SOCIAL_NETWORKS: 'socialNetworks',
  SETTINGS_NOTIFICATIONS: 'settingsNotifications',
  SETTINGS_USER_PAYMENT_METHODS: 'userPaymentMethods',
  USER_PASSWORD: 'userPassword',
  INSTALLMENTS: 'installments',
  SETTINGS_COOKIE_POLICY: 'settingsCookiePolicy',
  USER_SETTING: 'userSetting',
  HOME_COURSES: 'home-courses',
  HOME_EVENTS: 'home-events',
  HOME_CATALOG: 'home-catalog',
  COURSE_FREEZE: 'courseFreeze',
  BANNERS: 'banners',
  POINTS_HISTORY: 'points-history',
  NEW_COURSE: 'new-course',
  CATALOG: 'catalog',
  NOT_FOUND: '404'
}
